export function getTableMappingIdForCountryCode(countryCode: string) {
  const countryCodeSizeNameFieldMap: Record<string, string> = {
    FR: "BEF",
    ES: "BEF",
    PT: "BEF",
    IT: "Italy & CZ",
    GB: "UK",
    IE: "UK",
    US: "US",
    CA: "US",
    AU: "Australia",
    NZ: "Australia",
  };

  const activeSizeChart = countryCodeSizeNameFieldMap[countryCode] ?? "Europe";

  return activeSizeChart;
}
